(function () {
    var isNativeEmbedded = typeof C24App !== 'undefined' &&
        (C24App.isiOSBridgeAvailable() || C24App.isAndroidBridgeAvailable());

    var isProd = window.location.hostname.indexOf('check24.de') !== -1;
    var path = window.location.pathname;
    var isCat = path.indexOf('/katzenversicherung') === 0;
    var isTv = path.indexOf('/tierversicherung') === 0;

    var config = {
        agentSlug: 'tierkrankenversicherung',
        productKey: 'hundeversicherung',
        pageDescription: 'Der Kunde befindet sich momentan auf einer Landing-Page. Landing-Pages sind die erste Seite für Tierkrankenversicherungen. Es gibt verschiedene Landingpages für die verschiedenen angebotenen Tierkrankenversicherungen (Hund/Katze, Voll-/OP-Schutz). Hier erhält der Kunde erste generelle Informationen zum Produkt Tierkrankenversicherungen. Er kann den Namen seines Tieres bereits angeben und auf die Seite "Erste Angaben" weitergehen.',
        customContext: {'currentPage' : 'Landing-Page für Hundekrankenversicherungen'},
        initialState: 'hidden',
        openState: 'half-sheet',
        enabledDevices: ['desktop', 'mobile', 'app']
    };

    if (isCat) {
        config.productKey = 'katzenversicherung';
        config.customContext = {'currentPage': 'Landing-Page für Katzenversicherungen'};
    } else if (isTv) {
        config.productKey = 'tierversicherung';
        config.pageDescription = 'Der Kunde befindet sich auf der Produktstartseite (PSS) für Tierversicherungen. Hier kann der Kunde zwischen Haftpflicht- und Krankenversicherung für Hunde, Katzen und Pferde wählen und einen Vergleich starten.';
        config.customContext = {'currentPage': 'PSS für Tierversicherungen'};
    }

    window.c24TheBotSettings = config;

    // Native app provides The Bot itself — do not load web scripts
    if (isNativeEmbedded) {
        return;
    }

    var loaderSrc = isProd
        ? 'https://chat.bot.check24.de/the-bot-loader.js'
        : 'https://chat.bot.check24-test.de/the-bot-loader.js';

    var script = document.createElement('script');
    script.src = loaderSrc;
    script.defer = true;
    document.head.appendChild(script);
})();